import React from "react";
import { useGetTeamQuery } from "../../redux/features/teams/teamsApi";
import SingleUser from "../user/SingleUser";
import TeamHeader from "./TeamHeader";
import TeamList from "./TeamList";

function TeamBoard() {
  return (
    <>
      <TeamHeader />
      <TeamList />
    </>
  );
}

export default TeamBoard;
